<div class="login-container">
    <div class="login-card">
        <!-- Branding Section -->
        <div class="branding-section">
            <div class="brand-header">
                <div class="hallmark"></div>
                <div class="title-section">
                    <h2 class="main-title">NDA Assist</h2>
                    <p class="subtitle">CHEVRON LEGAL INTELLIGENCE PLATFORM</p>
                </div>
            </div>
        </div>

        <!-- Login Form Section -->
        <form class="login-form" (ngSubmit)="onSignIn()">
            <!-- Email Input -->
            <div class="form-group">
                <label for="email" class="form-label">Email</label>
                <input 
                    type="email" 
                    id="email" 
                    class="form-input"
                    [(ngModel)]="email"
                    name="email"
                    placeholder="admin@ndaassist.com"
                    [disabled]="isLoading"
                    (keypress)="onKeyPress($event)"
                >
            </div>

            <!-- Password Input -->
            <div class="form-group">
                <label for="password" class="form-label">Password</label>
                <div class="password-input-wrapper">
                    <input 
                        [type]="showPassword ? 'text' : 'password'" 
                        id="password" 
                        class="form-input"
                        [(ngModel)]="password"
                        name="password"
                        placeholder="••••••••••"
                        [disabled]="isLoading"
                        (keypress)="onKeyPress($event)"
                    >
                    <button 
                        type="button" 
                        class="password-toggle"
                        (click)="togglePasswordVisibility()"
                        [disabled]="isLoading"
                        tabindex="-1"
                    >
                        <span class="material-icons">{{ showPassword ? 'visibility' : 'visibility_off' }}</span>
                    </button>
                </div>
            </div>

            <!-- Error Message -->
            <div *ngIf="errorMessage" class="alert alert-error">
                <span class="material-icons">error</span>
                <span>{{ errorMessage }}</span>
            </div>

            <!-- Success Message -->
            <div *ngIf="successMessage" class="alert alert-success">
                <span class="material-icons">check_circle</span>
                <span>{{ successMessage }}</span>
            </div>

            <!-- Sign In Button -->
            <button 
                type="submit" 
                class="btn-signin"
                [disabled]="isLoading"
            >
                <span *ngIf="!isLoading">Sign in</span>
                <span *ngIf="isLoading" class="loading-spinner">
                    <span class="spinner"></span>
                    Signing in...
                </span>
            </button>
        </form>
    </div>

    <!-- Copyright Text -->
    <div class="copyright-text">
        <p>&copy; 2025 Chevron Corporation — NDA Assist v2</p>
    </div>
</div>
